import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { getStoredUser, isAuthenticated } from '@/lib/auth';
export function useMe() {
    return useQuery({
        queryKey: ['me'],
        queryFn: () => apiClient('/auth/me'),
        initialData: () => getStoredUser() ?? undefined,
        enabled: isAuthenticated(),
        staleTime: 1000 * 60 * 5,
    });
}
//# sourceMappingURL=useMe.js.map